<template>
  <div class="agent-commission-item" style="border:solid 1px #eee; margin-bottom: 15px;" v-show="show && !noshare">
    <div class="page-header" style="margin:0 0 10px 0;padding: 10px;background-color:#eeeeee9e">
      <div class="row">
        <div class="col-sm-6">
          <h3>{{ $t('games.' + game) }}</h3>
        </div>
        <div class="col-sm-6 text-right">
          <button class="btn btn-sm btn-warning" :disabled="noshare" @click.prevent="handleOnApplyAll">ตั้งค่าเกมส์อื่นๆตาม</button>
        </div>
      </div>
    </div>
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-sm-2 control-label">ส่วนแบ่งมาสเตอร์</label>
        <div class="col-sm-2">
          <div class="input-group">
            <input type="number" class="form-control" disabled="disabled" v-model="share.master">
            <span class="input-group-addon">%</span>
          </div>
        </div>
        <div class="col-sm-4 col-offset-4">
          <div class="input-group">
            <span class="input-group-addon">
              ขอคืนส่วนแบ่ง
              <input type="checkbox" v-model="enableReturn" @click="handleOnCheckReturn" :disabled="noshare">
            </span>
            <input type="number" class="form-control" :name="'returning.' + game"
              :readonly="!enableReturn || noshare"
              v-model="share.return"
              @click="handleOnInputShare($event, 'return')"
              @keyup="handleOnInputShare($event, 'return')">
            <span class="input-group-addon">%</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="inputEmail3" class="col-sm-2 control-label">แบ่งให้ดีลเลอร์</label>
        <div class="col-sm-2">
          <div class="input-group">
            <input type="number" class="form-control" :name="'share.' + game"
              :readonly="amount <= 0"
              v-model="share.agent"
              @click="handleOnInputShare($event, 'agent')"
              @keyup="handleOnInputShare($event, 'agent')">
            <span class="input-group-addon">%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MasterAgentShareItem from './MasterAgentShareItem'
  export default {
    name: 'master-agent-share-item',
    props: {
      game: {
        required: true,
        type: String
      },
      show: {
        required: false,
        type: Boolean,
        default: true
      },
      amount: {
        required: true,
        type: [String, Number]
      },
      broadcast: {
        required: true
      },
      shareAmount: {
        required: true,
        type: [String, Number]
      },
      returning: {
        required: false,
        // type: [String, Number]
      }
    },
    data () {
      return {
        enableReturn: false,
        share: {
          master: this.amount,
          return: 0,
          agent: 0
        }
      }
    },
    computed: {
      noshare () {
        return this.amount <= 0
      }
    },
    mounted () {
      // console.log(this.childData)
    },
    methods: {
      handleOnInputShare (e, group) {
        const value =  _.isObject(e) ? e.target.value : e
        const amount = value || 0
        const share = {}
        _.map(_.clone(this.share), (v, k) => {
          const number = v ? parseFloat(v) : 0
          Object.assign(share, { [k]: parseFloat(number) })
        })

        const another = _.omit(share, ['master', group])
        let summary = 0
        _.each(another, (v) => { summary += _.isNaN(v) ? 0 : v })

        const total = this.amount - summary

        share['master'] = total - amount
        share[group] = amount

        if (!value) {
          this.share.master = total
          this.share[group] = 0
          return
        }

        if (amount > total) {
          share[group] = total
          share['master'] = 0
        }

        this.share = share
      },
      handleOnCheckReturn (e) {
        const checked = e.target.checked
        if (!checked) {
          this.share.master += parseFloat(this.share.return)
          this.share.return = 0
        }
      },
      handleOnApplyAll () {
        this.$emit('update:broadcast', {
          from: this.game,
          data: _.cloneDeep(this.$data)
        })
      }
    },
    watch: {
      'broadcast': {
        handler: function (value, old) {
          const from = _.get(value, 'from')
          const data = _.get(value, 'data')
          if (_.eq(this.game, from) || this.amount == 0) {
            return
          }

          // if (this.game === 'hilo_hitech') {
          //   console.log(data)
          // }

          this.handleOnInputShare(data.share.agent, 'agent')
          this.handleOnInputShare(data.share.return, 'return')


          this.enableReturn = data.enableReturn
          if (!this.enableReturn) {
            this.share.return = 0
          }
        },
        deep: true
      },
      'shareAmount': {
        handler: function (value, old) {
          const amount = parseFloat(value)
          if (amount > 0) {
            this.handleOnInputShare(amount, 'agent')
          }
        },
        immediate: true
      },
      'returning': {
        handler: function (value, old) {
          const amount = parseFloat(value)
          if (amount > 0) {
            this.enableReturn = true
            this.handleOnInputShare(amount, 'return')
          }
        },
        immediate: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MasterAgentShareItem.vue